module.exports = __webpack_public_path__ + "public/img/logo-xiaohudi.991243a4.png";